import React from 'react';
import { useTranslation } from 'react-i18next';
import PageHeader from '@/components/layout/PageHeader';

const SettingsBilling: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div className="max-w-3xl mx-auto">
      <PageHeader title={t('pages.settingsBilling.title')} />
      <div className="px-6 pt-4 space-y-1">
        <p className="text-sm text-slate-500">{t('pages.settingsBilling.placeholder')}</p>
        <p className="text-sm text-slate-400">{t('pages.settingsBilling.underDevelopment')}</p>
      </div>
    </div>
  );
};

export default SettingsBilling;
